import { render, staticRenderFns } from "./stepHeader.vue?vue&type=template&id=4d56f802&"
import script from "./stepHeader.vue?vue&type=script&lang=ts&"
export * from "./stepHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports